import React from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import Anime from 'animejs';
import { FormControlLabel, Checkbox } from '@mui/material';
import { Animations } from '../../../../../constants/animations';
import { IAppState } from '../../../../../state/reducers';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import {
  RefreshIcon,
  ShareAllIcon,
  ReviewJobsIcon,
} from '../../../../Shared';
import {
  queueSelectedAssets,
  selectIsAssetsSelected,
  updateDownloads,
  startBackgroundTask,
  stopBackgroundTask,
  toggleBackgroundTask,
  selectSelectedAssets,
} from '../../../../../state/exchange/searchResults';
import { openJobStatusReview } from '../../../../../state/jobStatus';
import { Container, Pane } from './styles';
import { VAULT_MEDIA_TYPE } from '../../../../../constants';
import { isSoftball } from '../../../../../utils/exchange';
import { selectHasDownloadPermission, selectIsUserExchangeVendor } from '../../../../../state/user/userOrgRole';
import { Sport } from '../../../../../enums';

class ExchangeResultsActions extends React.Component<IProps> {
  componentDidMount() {
    const {
      isBackgroundTask,
      onStartBackgroundTask,
    } = this.props;

    if (isBackgroundTask) {
      onStartBackgroundTask();
    }
  }

  isShareDisabled = () => {
    const {
      games,
      isAssetsSelected,
      sport,
    } = this.props;

    return games === null || !isAssetsSelected || isSoftball(sport);
  };

  onDownloadClick = (e: MouseEvent) => {
    const { queueSelectedAssetsConnect } = this.props;

    e.stopPropagation();
    queueSelectedAssetsConnect();
    Anime({
      targets: e.target,
      ...Animations.ANIME_SHARE_BOUNCE,
    });
  };

  onUpdateDownloadsClick = (e: MouseEvent) => {
    const { onUpdateDownloads } = this.props;

    e.stopPropagation();
    onUpdateDownloads();
    Anime({
      targets: e.target,
      ...Animations.ANIME_SHARE_BOUNCE,
    });
  };

  getDownloadText(): string {
    const { selectedAssets, subscription: { isPushToCloud } } = this.props;
    const pushToCloudText = 'Send to ThunderCloud';
    const sendToConsoleText = 'Add to Console Queue';
    if (!isPushToCloud) {
      return sendToConsoleText;
    }

    let totalNonVideo = 0;
    selectedAssets.forEach((asset) => {
      if (asset.type !== VAULT_MEDIA_TYPE.video) {
        totalNonVideo += 1;
      }
    });

    if (totalNonVideo === selectedAssets.length) {
      return sendToConsoleText;
    }
    return pushToCloudText;
  }

  render() {
    const {
      subscription: {
        isPushToCloud,
      },
      isBackgroundTask,
      onToggleBackgroundTask,
      canDownload,
      vendorSport,
    } = this.props;

    if (!canDownload && !isPushToCloud && vendorSport === Sport.Football) return <></>;

    return (
      <Container>
        <Pane>
          <span
            data-tip={this.getDownloadText()}
            data-for="actions-tooltip"
            data-tip-disable={this.isShareDisabled()}
          >
            <ShareAllIcon
              onClick={this.onDownloadClick}
              disabled={this.isShareDisabled()}
            />
          </span>
          <span
            data-tip="Review Job Status"
            data-for="actions-tooltip"
          />
          <span
            data-tip={isPushToCloud ? 'Refresh Pushed To Cloud' : 'Refresh Downloads'}
            data-for="actions-tooltip"
          >
            <RefreshIcon
              onClick={this.onUpdateDownloadsClick}
              disabled={isBackgroundTask}
            />
          </span>
        </Pane>
        <Pane>
          <span>
            <FormControlLabel
              label={isPushToCloud ? 'Refresh Pushed To Cloud' : 'Refresh Downloads'}
              control={(
                <Checkbox
                  checked={isBackgroundTask}
                  onChange={onToggleBackgroundTask}
                  name="update-downloads"
                />
              )}
            />
          </span>
        </Pane>
        <ReactTooltip
          id="actions-tooltip"
          delayShow={250}
          effect="solid"
        />
      </Container>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  games: state.exchange.searchResults.games,
  sport: state.exchange.initExchange.sport,
  subscription: state.exchange.contentPreferences.subscription,
  isAssetsSelected: selectIsAssetsSelected(state),
  selectedAssets: selectSelectedAssets(state),
  isBackgroundTask: state.exchange.searchResults.isBackgroundTask,
  canDownload: selectHasDownloadPermission(state),
  vendorSport: state.exchange.searchParams.sportFilter,
});

const mapDispatchToProps: IDispatchProps = {
  queueSelectedAssetsConnect: queueSelectedAssets,
  onUpdateDownloads: updateDownloads,
  onStartBackgroundTask: startBackgroundTask,
  onStopBackgroundTask: stopBackgroundTask,
  onToggleBackgroundTask: toggleBackgroundTask,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeResultsActions);
